/** 折线图 */
<template>
  <div class="exchange-list-wrap margin-top-20">
    <ve-line
      :data="chartData"
      :extend="extend"
      :settings="chartSettings"
    ></ve-line>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";

export default {
  name: "AccountLayout",
  components: {
  },
  props: {
    chartData: {},
    extend: {
      "xAxis.0.axisLabel.rotate": 45,
    },
    chartSettings: {
      scale: [true, true],
    },
  },
};
</script>


